import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { IAnnouncementPaginatedResponse, getAnnouncementsPaginated } from "api";
import { Nullable } from "config";
import { RootState } from "store";

import { AnnouncementModalModes } from "./enums";
import { IAnnouncementModal } from "./types";

const initialState = {
  announcementsData: null as Nullable<IAnnouncementPaginatedResponse["edges"]>,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: AnnouncementModalModes.VIEW,
  } as IAnnouncementModal,
};

export const fetchAnnouncements = createAsyncThunk(
  "announcements/fetchAnnouncements",
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getAnnouncementsPaginated(filters);
    return response;
  }
);

const announcementSlice = createSlice({
  name: "announcements",
  initialState,
  reducers: {
    setAnnouncementModalData: (
      state,
      action: PayloadAction<IAnnouncementModal>
    ) => {
      state.modalData = action.payload;
    },
    closeAnnouncementModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchAnnouncements.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        announcementsData: action.payload?.edges ?? null,
        totalCount: action.payload?.totalCount ?? 1,
      };
    });
    builder.addCase(fetchAnnouncements.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const { setAnnouncementModalData, closeAnnouncementModal } =
  announcementSlice.actions;

export default announcementSlice.reducer;
